import { Box, IconButton, styled, Tooltip, Typography } from '@mui/material'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import { intl } from '../../../../i18n'
import { AggregateField } from '../../../../domain/entity/WbsItemEntity'
import { WorkloadUnit } from '../../../../lib/functions/workload'
import { WorkloadUnitToggleGroup } from '../../../components/toggleGroups/WorkloadUnitSelect'
import { colorPalette } from '../../../style/colorPalette'
import { FontSize } from '../../../../styles/commonStyles'

type Props = {
  aggregateField: AggregateField
  workloadUnit: WorkloadUnit
  onChangeWorkloadUnit: (unit: WorkloadUnit) => void
  onClickChange: () => void
}

export const UnitHeader = (props: Props) => {
  const { aggregateField, workloadUnit, onChangeWorkloadUnit, onClickChange } =
    props

  const fieldLabel = intl.formatMessage({
    id:
      aggregateField === AggregateField.WBS_ITEM_COUNT
        ? 'projectPlan.wbs.item.count'
        : 'projectPlan.wbs.item.workload',
  })

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 2 }}>
      <LabelText>
        {intl.formatMessage(
          { id: 'programProjectReport.unitSetting.headerInputUnit' },
          { field: fieldLabel }
        )}
      </LabelText>
      <Tooltip
        title={intl.formatMessage({
          id: 'programProjectReport.unitSetting.changeTooltip',
        })}
      >
        <IconButton size="small" onClick={onClickChange}>
          <SettingsOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
        <WorkloadUnitToggleGroup
          value={workloadUnit}
          refresh={onChangeWorkloadUnit}
        />
      </Box>
    </Box>
  )
}

const LabelText = styled(Typography)({
  whiteSpace: 'nowrap',
  color: colorPalette.monotone[4],
  fontSize: FontSize.MEDIUM,
})
